import React from 'react';

function Alerts() {
  return (
    <div className='text-black'>
      <h2 className='text-2xl mb-4'>Alerts</h2>
      <p>Alerts content will be implemented here.</p>
    </div>
  );
}

export default Alerts;
